export default function($) {
  $('.bxslider').bxSlider({
    'hideControlOnEnd': true,
    'speed': 225,
    'easing': 'cubic-bezier(0,0.66,0.45,0.99)',
    'pagerCustom': '.js-bxpager',
    onSliderLoad: function() {
      $(".js-variations").css("visibility", "visible");
    }
  });
}
